import React, { useState } from 'react';
import { Box, ITheme, IconButton, useTheme } from '@mui/material';
import ReportsListItem from './ReportsListItem';
import { ReportItem } from '../../models/Common';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';

export interface IReportsListProps {
    reports: ReportItem[];
    withPagination?: boolean;
}

const ReportsList: React.FC<IReportsListProps> = ({ reports, withPagination }) => {
    const theme = useTheme() as ITheme;
    const { t } = useTranslation();
    const [page, setPage] = useState(0);

    const pageSize = 5
    const pageCount = Math.floor((reports.length - 1) / pageSize);

    const onNext = () => {
        setPage(page + 1);
    }

    const onPrevious = () => {
        setPage(page - 1);
    }

    return <Box display={"flex"} flexWrap={"wrap"} gap={"14px"} justifyContent={"flex-start"} width={"100%"}>
        {withPagination && <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <IconButton sx={{ height: "50px", width: "50px" }} disabled={page === 0} onClick={onPrevious} aria-label={t('A11yPreviousPageButton')}>
                <ArrowBackIosNewIcon sx={{ fontSize: "40px", color: page === 0 ? theme.palette.grey[300] : theme.palette.primary.dark }} />
            </IconButton>
        </Box>}
        {withPagination ?
            reports.slice(page * pageSize, (page + 1) * pageSize).map(r => (<ReportsListItem report={r} key={`report-${r.id}`} />))
            :
            reports.slice(page * pageSize, (page + 1) * pageSize).map(r => (<ReportsListItem report={r} key={`report-${r.id}`} />))
        }
        {withPagination && <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <IconButton sx={{ height: "50px", width: "50px" }} disabled={page === pageCount} onClick={onNext} aria-label={t('A11yNextPageButton')}>
                <ArrowForwardIosIcon sx={{ fontSize: "40px", color: page === pageCount ? theme.palette.grey[300] : theme.palette.primary.dark }} />
            </IconButton>
        </Box>}
    </Box>;
}

export default ReportsList;